<label class="relative block cursor-pointer">
  <input type="checkbox" class="peer sr-only" [checked]="value()" (change)="onValueChange($event)" />
  <div class="absolute inset-0 rounded-lg bg-slate-100 peer-focus-visible:ring-2 peer-focus-visible:ring-slate-900/20"></div>
  <div class="absolute inset-1 scale-0 rounded-md bg-white transition-transform peer-checked:scale-100"></div>
  <span class="relative block p-2 text-center text-slate-500 peer-checked:text-slate-900">
    <ng-content></ng-content>
  </span>
</label>
